import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Performance() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/performance").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-8 text-tc-muted font-mono text-sm">Loading performance…</div>;

  const metrics = [
    ["Simulated Trades", d.total_trades], ["PASS Decisions", d.pass_decisions, "text-tc-pass"],
    ["Avg Process Score", `${d.avg_process_score}/100`, "text-tc-mastery"],
    ["Plan Adherence", `${d.plan_adherence}%`, "text-tc-bull"],
    ["Stop Adherence", `${d.stop_adherence}%`, "text-tc-bull"],
    ["Avg R", d.avg_r], ["Avg Planned R:R", d.avg_planned_rr],
    ["Win Rate", `${d.win_rate}%`], ["Avg Winner", `$${d.avg_winner}`, "text-tc-bull"],
    ["Avg Loser", `$${d.avg_loser}`, "text-tc-bear"], ["Profit Factor", d.profit_factor],
  ];

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Performance</h1>
        <p className="text-tc-sub mt-1">{d.note}</p>
      </div>

      {/* Process score is the hero, not balance */}
      <div className="tc-card p-6 bg-gradient-to-br from-tc-mastery/10 to-transparent border-tc-mastery/25 text-center">
        <div className="text-[11px] font-mono uppercase tracking-widest text-tc-mastery">Average Process Score</div>
        <div className="font-mono text-5xl font-bold mt-1" data-testid="perf-avg-score">{d.avg_process_score}<span className="text-lg text-tc-muted">/100</span></div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {metrics.map(([l, v, a]) => (
          <div key={l} className="tc-card p-4"><div className="text-[10px] font-mono uppercase tracking-widest text-tc-muted">{l}</div>
            <div className={`font-mono text-xl font-semibold mt-1 ${a || "text-tc-txt"}`}>{v}</div></div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="tc-card p-5">
          <h3 className="font-heading font-semibold mb-3">Rule Violations</h3>
          {d.violations.length === 0 ? <p className="text-sm text-tc-muted">No violations recorded. Excellent discipline.</p> : (
            <div className="space-y-2">{d.violations.map((v) => (
              <div key={v.code} className="flex justify-between text-sm"><span className="text-tc-sub">{v.code.replace(/_/g, " ")}</span><span className="font-mono text-tc-pass">{v.count}</span></div>
            ))}</div>
          )}
        </div>
        <div className="tc-card p-5">
          <h3 className="font-heading font-semibold mb-3">Performance By Emotional State</h3>
          {d.by_emotion.length === 0 ? <p className="text-sm text-tc-muted">No data yet.</p> : (
            <div className="space-y-2">{d.by_emotion.map((e) => (
              <div key={e.emotion} className="flex justify-between text-sm"><span className="text-tc-sub">{e.emotion} <span className="text-tc-muted">({e.count})</span></span><span className="font-mono text-tc-mastery">{e.avg_score}/100</span></div>
            ))}</div>
          )}
        </div>
      </div>
    </div>
  );
}
